<template>
  <div class="bg-teal-50">
    <div class="pt-6 max-w-screen-xl mx-auto">
      <div class="px-4 sm:px-6 lg:px-8 pb-8">
        <img class="h-8 sm:h-18 w-auto" src="@/assets/SolvasLogoShort.png" />
        <div
          class="flex flex-col lg:flex-row justify-between pb-16 lg:pt-8 xl:pt-20 xl:pb-24"
        >
          <div
            class="flex-grow lg:mx-0 text-center lg:text-left mt-12 sm:mt-16 md:mt-20 lg:mt-28 xl:mt-32"
          >
            <h2
              class="text-3xl tracking-tight leading-10 font-extrabold text-gray-900 sm:leading-none md:text-4xl lg:text-5xl"
            >
              Solvas
              <br />
              <span class="text-teal-600">Verzekeringsbewijzen</span>
            </h2>
            <Search v-on="$listeners" />
            <a
              @click="$emit('manual')"
              class="mt-1 inline-block text-teal-500 font-medium hover:text-teal-400 cursor-pointer"
              >Manueel opstellen</a
            >
            <div class="mt-4 max-w-lg lg:max-w-xl mx-auto lg:mx-0">
              <label
                class="block cursor-pointer"
                :class="{
                  'opacity-50 pointer-events-none': registrationLoading
                }"
                @dragover.prevent="dragActive = true"
                @dragleave.prevent="dragActive = false"
                @drop.prevent="onDrop"
              >
                <div
                  :class="[
                    'border-2 border-dashed rounded-md py-6 px-3 transition duration-150',
                    dragActive
                      ? 'border-teal-500 bg-teal-50'
                      : 'border-gray-300 hover:border-teal-400'
                  ]"
                >
                  <div class="flex justify-center mb-2">
                    <svg
                      class="h-8 w-8 text-teal-600"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                      />
                    </svg>
                  </div>
                  <p
                    v-if="registrationLoading"
                    class="text-center text-sm text-gray-600"
                  >
                    Document verwerken ...
                  </p>
                  <p
                    v-else
                    class="text-center text-sm font-semibold text-teal-400"
                  >
                    DIV inschrijving
                  </p>
                </div>
                <input
                  type="file"
                  accept=".pdf,application/pdf"
                  class="hidden"
                  :disabled="registrationLoading"
                  @change="onRegistrationUpload"
                />
              </label>
              <p
                v-if="registrationError"
                class="mt-2 text-xs text-red-600 text-center"
              >
                {{ registrationError }}
              </p>
              <p
                v-if="registrationSuccess"
                class="mt-1 text-xs text-teal-600 text-center"
              >
                {{ registrationSuccess }}
              </p>
            </div>
          </div>
          <div
            class="flex flex-col justify-end items-center lg:pl-8 pt-6 lg:pt-0"
          >
            <img
              class="w-96 md:w-auto"
              src="@/assets/data_process_monochromatic.svg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Search from '@/components/Search';
import { parseDivRegistration } from '@/divRegistration';

const MAX_FILE_SIZE = 20 * 1024 * 1024;

export default Vue.extend({
  name: 'Header',
  components: {
    Search
  },
  data: () => ({
    registrationLoading: false,
    registrationError: '',
    registrationSuccess: '',
    dragActive: false
  }),
  methods: {
    async processFile(file) {
      if (!file) return;

      if (file.size > MAX_FILE_SIZE) {
        this.registrationError = 'Bestand is groter dan 20MB.';
        return;
      }

      this.registrationLoading = true;
      this.registrationError = '';
      this.registrationSuccess = '';

      try {
        const result = await parseDivRegistration(file);
        this.registrationSuccess = result.vehicle.licensePlate
          ? `Gegevens geladen voor ${result.vehicle.licensePlate}`
          : 'Gegevens geladen';
        this.$emit('registration', result);
      } catch (err) {
        this.registrationError =
          (err && err.message) ||
          'Er is een fout opgetreden bij het verwerken van het document.';
      } finally {
        this.registrationLoading = false;
      }
    },
    onRegistrationUpload(event) {
      this.processFile(event.target.files[0]);
      event.target.value = '';
    },
    onDrop(event) {
      this.dragActive = false;
      const file = event.dataTransfer.files[0];
      if (file && file.type === 'application/pdf') {
        this.processFile(file);
      } else {
        this.registrationError = 'Alleen PDF-bestanden zijn toegestaan.';
      }
    }
  }
});
</script>
